import React from 'react';
import moment from 'moment';
import numberFormatter from '../../utils/numberFormatter.js'
import QueryStringService from '../../services/queryStringService.js'
import PanelService from '../../services/panelService';
import * as consts from '../../models/consts.js'

export default class CampaignDetailsPlay extends React.Component {
    constructor() {
        super();
        this.queryStringService = new QueryStringService();
        this.country = this.queryStringService.getCurrentCountry();
        this.state = {
            showScreens: true
        };
    }

    render() {
        let vac = numberFormatter.numberWithSpaces(this.props.selectedDetailsData.totalVAC);
        let showVac = false
        let alternateVac = numberFormatter.numberWithSpaces(this.props.selectedDetailsData.totalAlternateVAC);
        let plays = numberFormatter.numberWithSpaces(this.props.campaignInfo.plays)
        let screens = numberFormatter.numberWithSpaces(this.props.campaignInfo.notStarted ? 0 : this.props.campaignInfo.screens)
        let IDSScreens = 0;
        let periodWeeks = "Week " + moment(this.props.selectedDetailsData.startDate).format('W') + "-" + moment(this.props.selectedDetailsData.endDate).format('W');
        let showWeeks = false
        let showIDSScreens = false;
        const targetSov = this.props.selectedOrderLines[0].targetSoV;
        let showSoV = ['sfi', 'vac'].indexOf(this.props.selectedOrderLines[0].localParameter5.toLowerCase()) === -1;

        let spotlengthText = '';
        let sov = 0;
        let asterix = ''
        let extraValueLabel = this.props.extraValueLabel
        let extraValueValue = this.props.extraValueValue
        let showBookedScreens = false
        let showPlayoutScreens = true
        let targetScreens = this.props.selectedOrderLines[0].targetScreens

        switch (this.props.campaignPackagePromise) {
            case consts.CampaignPromisePackings.sov:
                sov = this.props.campaignInfo.soV;
                IDSScreens = numberFormatter.numberWithSpaces(
                    PanelService.getIDSPanels(this.props.selectedData.panels).length);
                showWeeks = true
                showIDSScreens = true;
                showBookedScreens = true;
                showPlayoutScreens = false
                asterix = this.country !== consts.Countries.dk ? '*' : '';
                break;

            case consts.CampaignPromisePackings.fxp:
                sov = this.props.campaignInfo.soV;
                IDSScreens = numberFormatter.numberWithSpaces(
                    PanelService.getIDSPanels(this.props.selectedData.panels).length);
                showVac = true
                showIDSScreens = true;
                asterix = this.country === consts.Countries.no ? '*' : '';
                break;

            case consts.CampaignPromisePackings.flexai:
                sov = this.props.campaignInfo.soV;
                IDSScreens = numberFormatter.numberWithSpaces(
                    PanelService.getIDSPanels(this.props.selectedData.panels).length);
                showVac = true
                showIDSScreens = true;
                asterix = this.country !== consts.Countries.dk ? '**' : '';
                break;
            case consts.CampaignPromisePackings.sovd:
                sov = this.props.campaignInfo.soV;
                showVac = true
                asterix = this.country !== consts.Countries.dk ? '**' : '';
                break;
            case consts.CampaignPromisePackings.vac:
                showVac = true
                break;
            case consts.CampaignPromisePackings.sovp:
                showSoV = false;
                IDSScreens = numberFormatter.numberWithSpaces(
                    PanelService.getIDSPanels(this.props.selectedData.panels).length);
                showVac = true;
                showIDSScreens = true;
                showBookedScreens = true;
                asterix = this.country !== consts.Countries.dk ? '*' : '';
                break;
            default:
                break;
        }

        if (this.props.spotlength === 'mixed'){
            spotlengthText = 'Mixed (' + this.props.selectedDetailsData.spotlengths.join(', ') + ')';
        }
        else if (this.props.spotlength !== ''){
            spotlengthText = this.props.selectedDetailsData.spotlengths[0];
        }
        return (
            <div className="campaign-details">
                <div className="row">
                    <div className="col-md-7" style={{'paddingBottom': '20px', 'minWidth': '280px'}}>
                        <table>
                            <tbody>
                                <tr>
                                    <th>Customer</th>
                                    <td>{this.props.orderData.customer}</td>
                                </tr>
                                {!showWeeks &&
                                <tr>
                                    <th>{'Period'}<br/>{(this.props.periodManuallySelected ? ' (manually selected)' :'') }</th>
                                    <td>{moment(this.props.selectedDetailsData.startDate).format('YYYY-MM-DD')}<br />{moment(this.props.selectedDetailsData.endDate).format('YYYY-MM-DD')}</td>
                                </tr>
                                }
                                {showWeeks &&
                                <tr>
                                    <th>{'Period'}<br/>{(this.props.periodManuallySelected ? ' (manually selected)' :'') }</th>
                                    <td>{periodWeeks}<br/> {moment(this.props.selectedDetailsData.startDate).format('YYYY-MM-DD') + " - "}{moment(this.props.selectedDetailsData.endDate).format('YYYY-MM-DD')}</td>
                                </tr>
                                }
                                {this.props.campaignName &&
                                <tr>
                                    <th>Campaign name</th>
                                    <td>{this.props.campaignName}</td>
                                </tr>
                                }
                                {showSoV &&
                                    <tr>
                                        <th>Booked SoV% (min)</th>
                                        <td>{numberFormatter.numberWithOneDecAndProcent(targetSov)}</td>
                                    </tr>
                                }
                                {showBookedScreens &&
                                    <tr>
                                        <th>Booked Screens (min)</th>
                                        <td>{numberFormatter.numberWithSpaces(targetScreens)}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className="col-md-5" style={{'minWidth': '240px'}}>
                        <h4 style={{marginTop: '0px', marginBottom: '6px'}}>Playout</h4>
                        <div style={{'border': 'solid 1px'}}>
                            <div style={{paddingRight:'10px', paddingLeft:'10px'}} >
                                <table>
                                    <tbody>
                                        <tr>
                                            <th>Spot length</th>
                                            <td>{spotlengthText} sec</td>
                                        </tr>
                                        <tr>
                                            <th>Plays</th>
                                            <td>{plays}</td>
                                        </tr>
                                        {this.state.showScreens && showPlayoutScreens &&
                                        <tr>
                                            <th>Screens</th>
                                            <td>{screens}</td>
                                        </tr>
                                        }
                                        {showIDSScreens &&
                                            <tr>
                                                <th>Screens in IDS</th>
                                                <td>{IDSScreens}</td>
                                            </tr>
                                        }
                                        {showSoV &&
                                        <tr>
                                            <th>Share of Voice</th>
                                            <td>{numberFormatter.numberWithOneDecAndProcent(sov)}</td>
                                        </tr>
                                        }
                                        {showSoV &&
                                        <tr>
                                            <th>(SoV)%</th>
                                            <td></td>
                                        </tr>
                                        }
                                        {showVac &&
                                        <tr>
                                            <th>VAC Contacts{asterix}</th>
                                            <td>{vac}</td>
                                        </tr>
                                        }
                                        {this.country !== consts.Countries.no && this.props.useAlternateContacts && this.props.spotlength === 10 &&
                                        <tr>
                                            <th>VAC Contacts (10 sec)</th>
                                            <td>{alternateVac}</td>
                                        </tr>
                                        }
                                        {this.country == consts.Countries.no && this.props.useAlternateContacts && this.props.spotlength === 5 &&
                                            <tr>
                                                <th>VAC Contacts (5 sec)</th>
                                                <td>{alternateVac}</td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {extraValueValue > 0 &&
                            <div>
                                <h4 style={{paddingTop: '8px', marginBottom: '6px'}}>Extra value</h4>
                                <div style={{'border': 'solid 1px'}}>
                                <div style={{paddingTop:'5px', paddingBottom:'5px', paddingRight:'10px', paddingLeft:'10px'}} >
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <th>{extraValueLabel}</th>
                                                    <td>{numberFormatter.numberWithSpaces(extraValueValue)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}